/**
 * @file 榜单详情页新增的vue数据store
 */
import * as Types from '../mutation-types';
import fetchData from '../../service';

const state = () => ({
    curRankIndex: 0, // 当前索引
    rankList: [], // 榜单详情页榜单数据
    storageAllRank: [],
    allRankAcIndex: 0,
    chooseRankIndex: 0
});

const mutations = {
    // 设置请求的榜单数据数组
    [Types.SET_RANK_DATA](state, data) {
        state.rankList = data;
    },
    // 设置当前榜单的索引
    [Types.SET_CUR_RANK_INDEX](state, data) {
        state.curRankIndex = data;
    },
    // 存储全部数组数据
    [Types.SET_ALL_RANK](state, data) {
        if (!state.storageAllRank[data.index].list.length) {
            state.storageAllRank[data.index].list.splice(0, 0, ...data.list);
        }
    },
    [Types.SET_DEFAULT_ALL_RANK](state, data) {
        state.storageAllRank = data;
        for (let i = 0; i < state.storageAllRank.length; i++) {
            state.storageAllRank[i].list = [];
        }
    },
    [Types.SET_ALL_RANK_AC_INDEX](state, data) {
        state.allRankAcIndex = data;
    },
    [Types.SET_CHOOSE_RANK_INDEX](state, data) {
        state.chooseRankIndex = data;
    }
};

const getters = {
};
const actions = {
    // 获取当前话题下的全景相册数据
    getFeedByTopic: ({rootState, commit}, params) => {
        let cuid = decodeURIComponent(rootState.urlParams.cuid);
        if (cuid === 'undefined' || cuid === undefined) {
            cuid = '';
        }
        let noCuid = cuid ? 0 : 1;
        const initParams = {
            qt: 'getfeedbytopic',
            cuid,
            channel_name: rootState.urlParams.channel_name
        };
        const {loc, channel_name, c: city_id} = rootState.urlParams;
        if (loc) {
            let formatLoc = loc.replace('(', '').replace(')', '');
            if (loc !== '0.000000,0.000000') {
                initParams.loc = formatLoc;
            }
        }
        if (city_id) {
            initParams.city_id = city_id;
        }
        if (channel_name) {
            initParams.channel_name = channel_name;
        }
        const fetchParam = Object.assign({}, initParams, params);

        return fetchData('getFeedByTopic', fetchParam, {noCuid: noCuid, need_sign: 1}).then(res => {
            if (res && res.result.error === 0 && res.content && res.content.length) {
                commit(Types.SET_RANK_DATA, res.content);
                return res.content;
            }
        }).catch(e => {
            console.error(e);
        });
    }
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};